"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationClientConfig = void 0;
var AuthenticationClientConfig = /** @class */ (function () {
    function AuthenticationClientConfig() {
        throw new Error('AuthenticationClientConfig ctor was called, expected to be overridden by IOC');
    }
    return AuthenticationClientConfig;
}());
exports.AuthenticationClientConfig = AuthenticationClientConfig;
//# sourceMappingURL=AuthenticationClientConfig.js.map